<template>
  <div
    class="content-card-old"
    :style="styleAttribute"
  >
    <video-player
      v-if="content.video && content.useVideo"
      class="content-card-old__media"
      controls-alignment="right"
      is-autoplay
      :video="content.video"
      :mobile-video="content.mobileVideo"
    >
      <content-card-text-old :content="content" />
    </video-player>

    <content-card-text-old
      v-else
      :content="content"
    >
      <art-direction
        v-if="content.image"
        class="content-card-old__media"
        :image-desktop="content.image || content.mobileImage"
        :image="content.mobileImage || content.image"
        :ratio="content.ratio"
        :ratio-desktop="content.ratio"
        :use-image-loading="useImageLoading"
        :breakpoint-sizes="breakpointSizes"
      />
    </content-card-text-old>
  </div>
</template>

<script>

/**
 * Vue: Content card
 * -----------------------------------------------------------------------------
 * Content card used for the main collection
 * @deprecated
 *
 * @param {Object} content - Content card Liquid object.
 *
 */
import { mapState } from 'vuex'

import ArtDirection from '~global/images/art-direction'

import VideoPlayer from '~async/video-player/video-player'
import ContentCardTextOld from '~async/main-collection/content-card/content-card-text-old'

export default {
  name: 'ContentCardOld',

  components: {
    ContentCardTextOld,
    ArtDirection,
    VideoPlayer,
  },

  props: {
    content: {
      type: Object,
      default: () => ({
        button: '',
        image: {},
        mobileImage: {},
        ratio: '',
        subtitle: '',
        title: '',
        url: '',
        useVideo: false,
        video: null,
        mobileVideo: null,
      }),
    },
    useImageLoading: {
      type: Boolean,
      default: true,
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Compute breakpoint sizes
     * @returns {string}
     */
    breakpointSizes() {
      const sizes = [390, 768, 1024, 1440 / 2, 1920 / 2, 2560 / 2]
      if (this.content.ratio === '.75:1') {
        return sizes.map(size => Math.round(size / 2)).join('-')
      }
      return sizes.join('-')
    },

    /**
     * Compute style attribute for mobile aspect ratio.
     * @returns {String|Null}
     */
    styleAttribute() {
      if (!this.isMobile) {
        return null
      }

      return `aspect-ratio: ${this.content.ratio.replace(':', '/')}`
    },
  },
}
</script>

<style lang="scss">
@import './content-card-old';
</style>
